import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import './Amount.module.css';

class Amount extends Component {
  state = {
    amount: this.props.defaultValue || 1
  };

  changeCallback = () => {
    if (this.props.onAmountChange) {
      this.props.onAmountChange(this.state.amount);
    }
  };

  changeAmount = step => {
    if (this.state.amount + step < 1) {
      return;
    }

    this.setState(
      state => ({
        amount: state.amount + step
      }),
      this.changeCallback
    );
  };

  handleAdd = () => {
    this.changeAmount(1);
  };

  handleSubstract = () => {
    this.changeAmount(-1);
  };

  handleChange = event => {
    this.setState(
      {
        amount: parseInt(event.target.value, 10)
      },
      this.changeCallback
    );
  };

  render() {
    const { defaultValue, t } = this.props;
    const value =
      (this.state.amount > 1 ? this.state.amount : false) || defaultValue || 1;

    return (
      <div styleName="container">
        <button styleName="button" onClick={this.handleSubstract}>
          -
        </button>
        <input
          styleName="input"
          type="text"
          value={value}
          onChange={this.handleChange}
          aria-label={t('Set quantity')}
        />
        <button styleName="button" onClick={this.handleAdd}>
          +
        </button>
      </div>
    );
  }
}

Amount.propTypes = {
  defaultValue: PropTypes.number,
  onAmountChange: PropTypes.func
};

export default DisplayComponent(withTranslation()(Amount));
